import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Factura } from 'src/app/Models/factura/factura';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { Personal } from 'src/app/Models/personal/personal';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';

@Component({
  selector: 'app-add-personal',
  templateUrl: './add-personal.component.html',
  styleUrls: ['./add-personal.component.css']
})
export class AddPersonalComponent implements OnInit {
  @ViewChild('frmpersonal', null) frmpersonal: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('artinfo', null) artinfo: InfoComponent;
  public funcion: Function;
  public isShow: boolean = false;
  public isedit: boolean = false;
  public usuario: any;
  public ingreso: Ingreso = new Ingreso();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public index: number = 0;
  public numitem: number = 0;
  public tiposgastos: any[] = [];
  tipodocumentos: any[] = [];
  public pagarticulo: any;
  public formapagos: any[] = []
  public niveles: any[] = [];
  public filtro: Filtro = new Filtro()
  public factura: Factura = new Factura()
  public listapersonal: Personal[] = [];
  public personal: Personal = new Personal()
  public newusuario: Usuario = new Usuario();
  public adduser: boolean = false;

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) {
    this.usuario = this.auth.getCurrentUser();
    this.tipodocumentos = [{ codigo: '1', descripcion: "DNI" }, { codigo: '4', descripcion: "CARNET DE EXTRANJERIA" }, { codigo: '-', descripcion: "OTROS" }]
    console.log(this.usuario);
    console.log(this.usuario.idpersonal.idpersonal);

  }

  ngOnInit() {


  }

  public show(affterfunction: Function = null) {

    this.funcion = affterfunction;
    this.isShow = true;
    this.personal.idsucursal = parseInt(this.data.getSucursalId())
    setTimeout(async () => {
      this.frmpersonal.nativeElement.click();
      this.artloading.show('Cargando datos');
      console.log(this.personal);
      this.GetNiveles()
      this.options.showCloseButton = true

      //this.PrepararData();
      if (this.isedit) {
        this.IsEdit()
      } else {
        this.personal.tipodocumento = '1'
      }
      this.artloading.hide();
    }, 10);
  }

  BusquedaReniec() {
    this.data.Consulta('ruc',this.personal.documento).then(r => {
      console.log(r);
      if (r.result==1) {
        //this.personal.nombre = r.nombres + ' ' + r.apellidoPaterno + ' ' + r.apellidoMaterno
        this.personal.nombre = r.message.razon_social
      } else {
        this.data.notify(r.message, 'Error', this.data.alertType.error)
      }
    }).catch(() => { this.data.notify("DNI invalido o no existente", 'Error', this.data.alertType.error) })
  }

  GetNiveles(){
    this.data.GetSimple(this.data.api.nivel).subscribe(
      (data)=>{
        this.niveles = data;
      },
      (error)=>{console.log(error);
      }
    )
  }

  asignarUsuario() {
    this.adduser = true
    this.generarPassword()
  }

  borrarusuario() {
    if (this.newusuario.username) {
      this.data.notify("Esta seguro de eliminar este usuario asignado a " + this.personal.nombre + "?", "Confirmar Operacion", this.data.alertType.info, this.options, () => {
        this.personal.idusuario ? this.deleteUser() : this.adduser = false
      })

    } else {
      this.adduser = false
    }
    this.personal.activo=false
    this.newusuario = new Usuario()
    console.log(this.newusuario);
    
  }

  IsEdit() {
    if (this.newusuario.username) {
      this.adduser = true
      this.generarPassword()
    } else {
      this.adduser = false
    }

  }

  onCheckboxChange(event: Event) {
    this.options.showCancelButton = true
    const checkbox = event.target as HTMLInputElement;
    if (!checkbox.checked && this.adduser) {
      this.data.notify("Esta seguro de desactivar este personal?", "Atencion", this.data.alertType.info, this.options, () => {
        this.borrarusuario()
      },()=>{checkbox.checked = false})
    } else {
      console.log('Activado');
    }
  }

  deleteUser() {
    console.log(this.personal.idusuario.id);

    this.data.Delete(this.data.api.user, this.personal.idusuario.id).subscribe(r => {
      this.newusuario = new Usuario()
      this.personal.idusuario = null
      this.adduser = false
    })
  }

  guardarUsuario(idpersonal: string) {
    this.newusuario.idpersonal = idpersonal
    this.data.Post(this.data.api.user, this.newusuario).subscribe((data) => {
      console.log("Usuario registrado", data)
      this.personal.idusuario = data
      this.ActualizarPersonal()
    }), (error) => { console.log(error) }
  }

  generarPassword() {

    let sendata = { nombre: this.personal.nombre, dni: this.personal.documento }
    if (sendata.nombre && sendata.dni) {
      this.data.Post('generarpass', sendata).subscribe((r) => {
        if (!this.newusuario.username) {
          this.newusuario.username = this.personal.documento
        }
        this.newusuario.password = r.password
        this.personal.activo=true
      }, (error) => { console.log("Error", error.error) })
    } else {
      this.adduser = false
      this.data.notify("Completar los datos faltantes", "Atencion", this.data.alertType.info, new ALertOption)
    }
  }

  Save() {
    if (this.personal.nombre && this.personal.documento) {
      this.isedit ? this.ActualizarPersonal() : this.GuardarPersonal()
    } else {
      this.data.notify("Completar los datos faltantes", "Atencion", this.data.alertType.info)
    }
  }

  GuardarPersonal() {
    console.log('Guardando personal');
    this.data.Post(this.data.api.personal, this.personal).subscribe((data) => {
      console.log("Personal registrado", data)
      this.personal.idpersonal = data.idpersonal
      this.guardarUsuario(data.idpersonal)
      this.data.notify("Personal registrado", "Exito", this.data.alertType.success, new ALertOption, () => { this.close() })
    }), (error) => { console.log(error) }
  }

  ActualizarPersonal() {
    console.log('Actualizando personal', this.personal);
    this.personal.idusuario ? this.personal.idusuario = this.personal.idusuario.id : this.personal.idusuario = null
    this.data.Put(this.data.api.personal, this.personal.idpersonal.toString(), this.personal).subscribe((data) => {
      if (!this.personal.idusuario && this.newusuario) {
        this.guardarUsuario(data.data.idpersonal)
      }
      this.isedit ? this.data.notify("Personal Actualizado", "Exito", this.data.alertType.success, new ALertOption, () => { this.close() }) : console.log("Personal actualizado", data)
    }), (error) => { console.log(error) }
  }

  refresh() {
    window.location.reload();
  }

  close() {
    this.btnclose.nativeElement.click();
    setTimeout(() => { this.isShow = false; }, 500);
    setTimeout(() => { if (this.funcion != null) { this.funcion(); } }, 10);
  }

}
